// extracted by mini-css-extract-plugin
export default {"sectionTitleWrapper":"sectionTitle_sectionTitleWrapper__tV-n+","cardContent":"sectionTitle_cardContent__N5TqV"};